import React from "react";
import DirectionsSubwayOutlinedIcon from "@mui/icons-material/DirectionsSubwayOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import TempleBuddhistOutlinedIcon from "@mui/icons-material/TempleBuddhistOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
import BakeryDiningOutlinedIcon from "@mui/icons-material/BakeryDiningOutlined";
import RamenDiningOutlinedIcon from "@mui/icons-material/RamenDiningOutlined";
import SetMealOutlinedIcon from "@mui/icons-material/SetMealOutlined";
import LocalDiningOutlinedIcon from "@mui/icons-material/LocalDiningOutlined";
import LunchDiningOutlinedIcon from "@mui/icons-material/LunchDiningOutlined";
import LocalCafeOutlinedIcon from "@mui/icons-material/LocalCafeOutlined";
import LandscapeOutlinedIcon from "@mui/icons-material/LandscapeOutlined";
import LocalPizzaOutlinedIcon from "@mui/icons-material/LocalPizzaOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import NightlifeOutlinedIcon from "@mui/icons-material/NightlifeOutlined";
import LocalBarOutlinedIcon from "@mui/icons-material/LocalBarOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import RestaurantMenuOutlinedIcon from "@mui/icons-material/RestaurantMenuOutlined";

const TIP_ICONS = {
	train: DirectionsSubwayOutlinedIcon,
	time: ScheduleOutlinedIcon,
	budget: PaymentsOutlinedIcon,
	walk: DirectionsWalkOutlinedIcon,
	shop: ShoppingBagOutlinedIcon,
	photo: PhotoCameraOutlinedIcon,
	panda: PetsOutlinedIcon,
	temple: TempleBuddhistOutlinedIcon,
	game: SportsEsportsOutlinedIcon,
	food: RestaurantOutlinedIcon,
	crepe: BakeryDiningOutlinedIcon,
	ramen: RamenDiningOutlinedIcon,
	seafood: SetMealOutlinedIcon,
	street: LocalDiningOutlinedIcon,
	bento: LunchDiningOutlinedIcon,
	cafe: LocalCafeOutlinedIcon,
	bridge: LandscapeOutlinedIcon,
	pizza: LocalPizzaOutlinedIcon,
	tower: AccountBalanceOutlinedIcon,
	night: NightlifeOutlinedIcon,
	bar: LocalBarOutlinedIcon,
};

const PlaceIcon = ({ name, className }) => {
	const Icon = TIP_ICONS[name] || LightbulbOutlinedIcon;
	return <Icon className={className} sx={{ fontSize: 22 }} />;
};

const RutaPlaceDetail = ({ info }) => {
	if (!info) return null;

	return (
		<div className="rutas-place-detail">
			<div className="rutas-place-header">
				<h2 className="rutas-place-title">{info.title}</h2>
				{info.tagline && (
					<p className="rutas-place-tagline">{info.tagline}</p>
				)}
			</div>

			<p className="rutas-day-description">{info.description}</p>

			{info.firstVisit && (
				<div className="rutas-place-first-visit">
					<span className="rutas-place-first-visit-label">
						<AutoAwesomeOutlinedIcon
							sx={{ fontSize: 16, mr: 0.5, verticalAlign: "text-bottom" }}
						/>
						Primera vez en Tokio
					</span>
					<p>{info.firstVisit}</p>
				</div>
			)}

			{info.tips?.length > 0 && (
				<>
					<div className="rutas-highlights-title">CONSEJOS ÚTILES</div>
					<ul className="rutas-place-tips">
						{info.tips.map((tip) => (
							<li key={tip.title} className="rutas-place-tip">
								<span className="rutas-place-tip-icon" aria-hidden>
									<PlaceIcon name={tip.icon} />
								</span>
								<div className="rutas-place-tip-body">
									<strong>{tip.title}</strong>
									<p>{tip.text}</p>
								</div>
							</li>
						))}
					</ul>
				</>
			)}

			{info.highlights?.length > 0 && (
				<>
					<div className="rutas-highlights-title">IMPERDIBLES</div>
					<div className="rutas-highlights">
						{info.highlights.map((h) => (
							<span key={h} className="rutas-highlight-chip">
								{h}
							</span>
						))}
					</div>
				</>
			)}

			{info.food && (
				<div className="rutas-place-food">
					<span className="rutas-place-food-icon" aria-hidden>
						<PlaceIcon name={info.food.icon} />
					</span>
					<div>
						<strong>
							<RestaurantMenuOutlinedIcon
								sx={{
									fontSize: 16,
									mr: 0.5,
									verticalAlign: "text-bottom",
									color: "#e8677d",
								}}
							/>
							Qué comer aquí
						</strong>
						<p>{info.food.text}</p>
					</div>
				</div>
			)}
		</div>
	);
};

export default RutaPlaceDetail;
